import styled from "styled-components";
import { colours } from "../../styles/colours.constants";
import { satoshi700 } from "../../styles/font.constants";
import { spacing } from "../../styles/styles.constants";

export const TabContainer = styled.div`
	display: flex;
	width: 100%;
	background: ${colours.greyDark};
	border-radius: ${spacing.borderRadius};
	padding: 0.25rem;
`;

type TabStyleProps = {
	$active: boolean;
	disabled: boolean;
	$width: number;
};

export const Tab = styled.button<TabStyleProps>`
	width: ${({ $width }) => $width}%;
	border-radius: ${spacing.borderRadius};
	appearance: none;
	border: none;
	cursor: ${({ $active, disabled }) => {
		if ($active) {
			return "default";
		}

		if (disabled) {
			return "not-allowed";
		}

		return "pointer";
	}};
	padding: 0.625rem 1rem;
	background-color: ${({ $active }) =>
		$active ? colours.white : colours.greyDark};
	${satoshi700}
	font-size: 1rem;
`;
